import React from "react";
import { motion } from "framer-motion";
import { Section } from "./Section";
import { about, profile } from "../../data/portfolio";

export const About = () => {
  return (
    <Section id="about" label="About" title="How I think about building software." index={1}>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-7 space-y-7">
          <p className="font-serif italic text-2xl md:text-3xl leading-[1.25] text-neutral-100">
            {about.intro}
          </p>
          {about.paragraphs.map((p, i) => (
            <p
              key={i}
              className="text-base md:text-lg leading-relaxed text-neutral-400 max-w-2xl"
            >
              {p}
            </p>
          ))}
        </div>

        <div className="lg:col-span-5 lg:pl-8 lg:border-l border-neutral-900 space-y-10">
          <div className="space-y-6">
            {about.highlights.map((h) => (
              <div
                key={h.k}
                className="flex items-baseline justify-between border-b border-neutral-900 pb-4"
              >
                <span className="text-mono-label">{h.k}</span>
                <span className="font-serif text-2xl text-neutral-100">{h.v}</span>
              </div>
            ))}
          </div>

          <div>
            <div className="text-mono-label mb-3">Currently</div>
            <p className="text-neutral-300 leading-relaxed">
              Membangun sistem yang jelas, terstruktur, dan bisa diandalkan.
            </p>
          </div>
        </div>
      </div>

      {/* Philosophy quote — the signature moment of the page */}
      <motion.figure
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-120px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="mt-24 md:mt-36 relative border-t border-neutral-900 pt-16 md:pt-24"
        data-testid="about-philosophy"
      >
        <div className="text-mono-label mb-8">Philosophy</div>
        <blockquote className="font-serif italic text-3xl sm:text-4xl md:text-5xl leading-[1.15] tracking-tight text-neutral-100 max-w-5xl">
          &ldquo;{profile.philosophy}&rdquo;
        </blockquote>
        <blockquote className="mt-6 font-serif italic text-xl sm:text-2xl md:text-3xl leading-[1.15] tracking-tight text-neutral-100 max-w-5xl">
          &ldquo;{profile.philosophyTranslation}&rdquo;
        </blockquote>
      </motion.figure>
    </Section>
  );
};

export default About;
